import React from 'react';
import {UserContextType} from 'components/triggers/UserContextType';

export default class UserRoleConditionComponent extends React.Component {
  render() {
    const {context, contextType} = this.props;
    const role = context.role.toLowerCase();
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            a user with role{' '}
            <span onClick={this.props.onClick} className="condition-action">
              '{role}'
            </span>{' '}
            reviews a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is placed or received by a user with role{' '}
            <span onClick={this.props.onClick} className="condition-action">
              '{role}'
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the call was placed or received by a user with role{' '}
            <span onClick={this.props.onClick} className="condition-action">
              {role}
            </span>
          </span>
        )}
      </div>
    );
  }
}
